module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"ctrl-psel-item\">\n    <span>")
    ; __append(escapeFn( _.get(item, control.titleKey) ))
    ; __append("</span>\n    ")
    ;  if (control.multiple && !viewOnly) { 
    ; __append("\n    	<a href=\"javascript:void(0)\" class=\"remove\" data-id=\"")
    ; __append(escapeFn( item.id ))
    ; __append("\">Удалить</a>\n    ")
    ;  } 
    ; __append("\n</div>\n")
  }
  return __output.join("");

}